import React from 'react';

const SocialProof = () => (
  <div className="py-16 bg-gray-50">
    <h2 className="text-3xl font-bold text-center text-blue-900 mb-4">Made in Milwaukee. Made for Developers.</h2>
    <p className="text-center text-gray-700 max-w-2xl mx-auto">We run Milwaukee-local to keep things fast, simple, and close to home.</p>
  </div>
);

export default SocialProof;
